import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18EditG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "evenodd",
      d: "M11.125 2.334a1.143 1.143 0 0 1 1.614 0l2.927 2.927a1.143 1.143 0 0 1 0 1.614l-8.623 8.622c-.2.2-.465.318-.747.333l-3.251.169a.995.995 0 0 1-1.044-.94v-.039l.17-3.316c.014-.282.132-.548.332-.747zM9.307 5.707 3.28 11.734a.05.05 0 0 0-.012.027l-.162 3.132 3.133-.161.014-.004.013-.008 6.14-6.14zm2.654-2.595a.04.04 0 0 0-.058 0l-1.818 1.817 3.097 2.873 1.706-1.705q.017-.017.011-.04l-.01-.019z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18EditG$1 = Svg18EditG;

export { Svg18EditG$1 as default };
